import Vue from 'vue';
import Router from 'vue-router';

import { Auth } from 'aws-amplify';

Vue.use(Router);

const appName = 'Smartology';

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'redirect',
      redirect: {
        name: 'login',
      },
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      // component: Dashboard,
      component: () => import(/* webpackChunkName: "dashboard" */ '@/views/Dashboard'),
      meta: {
        title: `Campaigns | My ${appName}`,
        requiresAuth: true,
        fullHeight: true,
        type: 'MY_DASHBOARD',
      },
    },
    {
      path: '/selfservice-dashboard',
      name: 'selfServiceDashboard',
      // component: Dashboard,
      component: () => import(/* webpackChunkName: "dashboard" */ '@/views/Dashboard'),
      meta: {
        title: `Self Service Campaigns | My ${appName}`,
        requiresAuth: true,
        fullHeight: true,
        type: 'SELF_SERVICE_DASHBOARD',
      },
    },
    {
      path: '/reports',
      name: 'reportsGeneratorDashboard',
      // component: ReportsGenerator,
      component: () => import(/* webpackChunkName: "dashboard" */ '@/views/ReportsGenerator/ReportsGenerator'),
      meta: {
        title: `Reports | My ${appName}`,
        requiresAuth: true,
        fullHeight: true,
      },
    },
    {
      path: '/on-boarding',
      name: 'onBoarding',
      // component: OnBoarding,
      component: () => import(/* webpackChunkName: "dashboard" */ '@/views/authentication/OnBoarding'),
      meta: {
        title: `User details | My ${appName}`,
        requiresAuth: true,
        fullHeight: true,
      },
    },
    {
      path: '/login',
      name: 'login',
      // component: Login,
      component: () => import(/* webpackChunkName: "login" */ '@/views/authentication/Login'),
      meta: {
        title: `Sign in | My ${appName}`,
      },
    },
    {
      path: '/register',
      name: 'register',
      // component: Register,
      component: () => import(/* webpackChunkName: "authentication" */ '@/views/authentication/Register'),
      meta: {
        title: `Register account | My ${appName}`,
      },
    },
    {
      path: '/confirm',
      name: 'confirm',
      // component: Confirm,
      component: () => import(/* webpackChunkName: "authentication" */ '@/views/authentication/Confirm'),
      meta: {
        title: `Confirm account | My ${appName}`,
      },
    },
    {
      path: '/verify',
      name: 'verify',
      // component: Verify,
      component: () => import(/* webpackChunkName: "login" */ '@/views/authentication/Verify'),
      meta: {
        title: `Verify | My ${appName}`,
      },
    },
    {
      path: '/forgot-password',
      name: 'forgotPassword',
      // component: ForgotPassword,
      component: () => import(/* webpackChunkName: "authentication" */ '@/views/authentication/ForgotPassword'),
      meta: {
        title: `Forgotten password | My ${appName}`,
      },
    },
    {
      path: '/verify-forgotten-password',
      name: 'verifyForgottenPassword',
      // component: VerifyForgottenPassword,
      component: () => import(/* webpackChunkName: "authentication" */ '@/views/authentication/VerifyForgottenPassword'),
      meta: {
        title: `Verify forgotten password | My ${appName}`,
      },
    },
    {
      path: '/confirm-forgotten-password',
      name: 'confirmForgottenPassword',
      // component: ConfirmForgottenPassword,
      component: () => import(/* webpackChunkName: "authentication" */ '@/views/authentication/ForgotPasswordConfirm'),
      meta: {
        title: `Confirm forgotten password | My ${appName}`,
      },
    },
    {
      path: '/new-password',
      name: 'newPasswordRequired',
      // component: NewPasswordRequired,
      component: () => import(/* webpackChunkName: "authentication" */ '@/views/authentication/NewPasswordRequired'),
      meta: {
        title: `Submit new password | My ${appName}`,
      },
    },
    {
      path: '/finish-account-setup',
      name: 'finishAccountSetup',
      // component: FinishAccountSetup,
      component: () => import(/* webpackChunkName: "authentication" */ '@/views/authentication/FinishAccountSetup'),
      meta: {
        title: `Submit new password | My ${appName}`,
      },
    },
    {
      path: '/new-campaign',
      name: 'NewCampaignBlank',
      // component: NewCampaign,
      component: () => import(/* webpackChunkName: "campaign" */ '@/views/Campaign/NewCampaign'),
      meta: {
        title: `Add your campaign | My ${appName}`,
        requiresAuth: true,
        fullHeight: true,
      },
    },
    {
      path: '/new-campaign/aid/:advertiserId/cid/:campaignId?',
      name: 'NewCampaign',
      // component: NewCampaign,
      component: () => import(/* webpackChunkName: "campaign" */ '@/views/Campaign/NewCampaign'),
      meta: {
        title: `Add your campaign | My ${appName}`,
        requiresAuth: true,
        fullHeight: true,
      },
    },
    {
      path: '/edit-campaign/aid/:advertiserId/cid/:campaignId',
      name: 'EditCampaign',
      // component: EditCampaign,
      component: () => import(/* webpackChunkName: "campaign" */ '@/views/Campaign/EditCampaign'),
      meta: {
        title: `Edit your campaign | My ${appName}`,
        requiresAuth: true,
        fullHeight: true,
      },
    },
    {
      path: '/view-campaign/aid/:advertiserId/cid/:campaignId',
      name: 'ViewCampaign',
      // component: EditCampaign,
      component: () => import(/* webpackChunkName: "campaign" */ '@/views/Campaign/EditCampaign'),
      meta: {
        title: `View your campaign | My ${appName}`,
        requiresAuth: true,
        fullHeight: true,
      },
    },
    {
      path: '/reporting/aid/:advertiserId/cid/:campaignId',
      name: 'ReportingIndex',
      // component: ReportingIndex,
      component: () => import(/* webpackChunkName: "reporting" */ '@/views/Reporting/Index'),
      meta: {
        title: `Reporting | My ${appName}`,
        requiresAuth: true,
        fullHeight: true,
      },
    },
    {
      path: '/showcase/',
      name: 'ShowcaseIndex',
      redirect: {
        name: 'dashboard',
      },
    },
    {
      path: '/showcase/:creativeKey?',
      name: 'Showcase',
      // component: Showcase,
      component: () => import(/* webpackChunkName: "showcase" */ '@/views/Showcase/CreativeView'),
      meta: {
        title: `Campaign showcase | My ${appName}`,
        requiresAuth: true,
        fullHeight: true,
      },
    },
    {
      path: '/cid/:campaignId?/showcase',
      name: 'Campaign Showcase',
      // component: Showcase,
      component: () => import(/* webpackChunkName: "showcase" */ '@/views/Showcase/CampaignView'),
      meta: {
        title: `Campaign showcase | My ${appName}`,
        requiresAuth: true,
        fullHeight: true,
      },
    },
    {
      path: '/billing',
      name: 'billing',
      // component: Billing,
      component: () => import(/* webpackChunkName: "billing" */ '@/views/Billing/Index'),
      meta: {
        title: `Billing | My ${appName}`,
        requiresAuth: true,
        fullHeight: true,
      },
    },
    {
      path: '/templates',
      name: 'templates',
      // component: Templates,
      component: () => import(/* webpackChunkName: "templates" */ '@/views/Templates/Templates'),
      meta: {
        title: `Templates | My ${appName}`,
        requiresAuth: true,
        fullHeight: true,
      },
    },
    {
      path: '/templates/create',
      name: 'TemplateCreate',
      component: () => import(/* webpackChunkName: "templates" */ '@/views/Templates/TemplateForm'),
      meta: {
        title: 'Create template',
      },
    },
    {
      path: '/templates/update/:id',
      name: 'TemplateUpdate',
      component: () => import(/* webpackChunkName: "templates" */ '@/views/Templates/TemplateForm'),
      meta: {
        title: 'Edit template',
      },
    },
    {
      path: '*',
      // component: NotFoundComponent,
      component: () => import(/* webpackChunkName: "dashboard" */ '@/views/NotFoundComponent'),
    },
  ],
});

router.beforeEach((to, from, next) => {
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.title);

  if (nearestWithTitle) document.title = `${nearestWithTitle.meta.title}`;

  next();
});
router.beforeResolve(async (to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    try {
      await Auth.currentAuthenticatedUser()
        .catch(() => {
          next({
            path: '/',
            query: {
              redirect: to.fullPath,
            },
          });
        });
      next();
    } catch (e) {
      next({
        path: '/',
        query: {
          redirect: to.fullPath,
        },
      });
    }
  }
  next();
});

export default router;
